import { z } from 'zod';

import { apiClient } from '@/lib/api-client';
import {
  mediaSchema,
  postListSchema,
  postPageSchema,
  postSchema,
  uploadUrlSchema,
  type Media,
  type Post,
  type PostPage,
  type UploadUrl,
} from '@/lib/schemas/post';

export interface CreatePostInput {
  type: string;
  scope: string;
  title?: string;
  body: string;
  town?: string;
  countryCode?: string;
  isAnonymous?: boolean;
  linkedPostId?: string;
  tags?: string[];
  mediaIds?: string[];
}

export const feedApi = {
  list: (query: Record<string, string>, signal?: AbortSignal): Promise<PostPage> =>
    apiClient.get('/posts', postPageSchema, { query, ...(signal ? { signal } : {}) }),

  get: (id: string, signal?: AbortSignal): Promise<Post> =>
    apiClient.get(`/posts/${id}`, postSchema, signal ? { signal } : {}),

  ideals: (id: string, signal?: AbortSignal): Promise<Post[]> =>
    apiClient.get(`/posts/${id}/ideals`, postListSchema, signal ? { signal } : {}),

  create: (body: CreatePostInput): Promise<Post> => apiClient.post('/posts', postSchema, { body }),

  update: (id: string, body: { title?: string; body?: string; tags?: string[] }): Promise<Post> =>
    apiClient.patch(`/posts/${id}`, postSchema, { body }),

  // 204 No Content: the client turns an empty body into null before validating.
  remove: (id: string): Promise<null> => apiClient.delete(`/posts/${id}`, z.null()),

  createUploadUrl: (mimeType: string, sizeBytes: number): Promise<UploadUrl> =>
    apiClient.post('/media/upload-url', uploadUrlSchema, { body: { mimeType, sizeBytes } }),

  completeUpload: (mediaId: string): Promise<Media> =>
    apiClient.post(`/media/${mediaId}/complete`, mediaSchema),
};
